const Url = {
    apiUrl: "https://api.ykshenzhen.com/api/",
    imgUrl: ""
}



export default Url;